export const JobData = [
  {
    company: "Microsoft via KarmHub",
    title: "Software Engineer",
    description: "",
    points: [
      "Collaborate and develop feature work on enterprise customer data platform.",
      "Create unit tests for existing codebase.",
    ],
    image: "msft-icon.jfif",
    technologies: [
      "TypeScript",
      "React",
    ],
  },
  {
    company: "Nucamp",
    title: "Coding Instructor",
    description: "",
    points: [
      "Lead server-side development workshops featuring NodeJs, Express & MongoDB.",
      "Fostered understanding alongside new web developers/software engineers.",
      "Coached and mentored students after administering technical whiteboard interviews.",
    ],
    image: "nucamp.png",
    technologies: [
      "JavaScript",
      "NodeJs",
      "Express",
      "MongoDB",
      "Mongoose",
      "Passport",
    ],
  },
  {
    company: "Off the Record",
    title: "Front End Developer",
    description: "",
    points: [
      "Took new mobile website menu functionality from inception through to production.",
      "Developed in AngularJS using SCSS, Gulp, Bootstrap. Updated existing codebase.",
      "Redesigned and implemented client dashboard feature. Made consistent functionality and styling while adding in proper mobile responsiveness to improve user experience.",
    ],
    image: "otr.png",
    technologies: [
      "JavaScript",
      "AngularJS",
      "SASS",
      "Bootstrap",
      "Bower",
      "Gulp",
    ],
  },
  {
    company: "DigitalCrafts",
    title: "Teacher Assistant",
    description: "",
    points: [
      "Mentored students in daily class projects, including day and a half hackathon.",
      "Reviewed teaching points of: delegates, design patterns, dynamics, events, attributes, Azure logic apps, web jobs, async programming, multithreading with 25 students.",
    ],
    image: "digitalcrafts-white.png",
    technologies: ["C#", "Azure Logic Apps"],
  },
  {
    company: "Safeway",
    title: "Maintenance Supervisor",
    description: "",
    points: [
      "Designed, developed, and implemented various PLCs, HMIs, control panels, and automation.",
      "Coded ladder logic and developed automation systems for food manufacturing equipment.",
    ],
    image: "safeway.png",
    technologies: ["Ladder Logic", "PLC", "UX/UI"],
  },
];
